import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  ListContainer: {
    backgroundColor: '#fff',
    flex: 1,
  },
  tchatBlock: {
    backgroundColor: '#F0F4F8',
    padding:16,
    borderRadius: 8,
  },
  tchatBlockrWrap: {
    flexDirection:'row',
    justifyContent:'flex-end'
  },
  tchatBlockresponse:{
    flexDirection: 'row',
    marginVertical: 8,
    padding: 16,
    backgroundColor: '#0F579E',
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    alignItems: 'flex-end',
    alignContent:'center',
    justifyContent: 'flex-start',
  },
  ListIOfItems:{


  },
  ListItemInRow: {
    flexDirection: 'row',
    marginVertical: 8,
    padding: 16,
    backgroundColor: '#1D5C42',
    borderRadius: 8,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  ListItemFont: {
    fontSize: 16,
    color:'#fff'
  },
});
